import { Box, Typography } from "@mui/material";
import { useState, useEffect } from "react";

function AppFooter() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Update window width on resize
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    // Clean up event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div>
      {windowWidth > 1024 ? (
        <Box display="flex" width="100vw" justifyContent="center">
          <Box
            display="flex"
            p={1}
            justifyContent="space-between"
            flex={1}
            maxWidth="1440px"
            alignItems="center"
          >
            <Box
              height="40px"
              width="110px"
              component="img"
              src="/images/appIcon.png"
            />
            <Typography>
              Copyright (c) gourmetnavi.com, Inc. All Rights Reserved.
            </Typography>
          </Box>
        </Box>
      ) : (
        <Box display="flex" width="100vw" justifyContent="center">
          <Box
            display="flex"
            p={1}
            justifyContent="space-between"
            flex={1}
            maxWidth="1440px"
            alignItems="center"
          >
            <Box
              height="40px"
              width="110px"
              component="img"
              src="/images/appIcon.png"
            />
            <Typography>@gourmetnavi.com, Inc.</Typography>
          </Box>
        </Box>
      )}
    </div>
  );
}

export default AppFooter;
